import { styled } from 'styled-system/jsx'

const PayStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
})

const PayHeader = styled('div', {
  base: {},
})

const PayTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const PaySubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    marginTop: '4px',
  },
})

const BreakdownList = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
  },
})

const BreakdownRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    paddingY: '10px',
  },
  variants: {
    emphasis: {
      standard: {},
      total: {
        borderTop: '1px solid #EFEDF5',
        marginTop: '4px',
        paddingTop: '14px',
      },
    },
  },
  defaultVariants: {
    emphasis: 'standard',
  },
})

const BreakdownLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
  variants: {
    emphasis: {
      standard: {},
      total: {
        fontWeight: '700',
        color: 'quickpass.ink',
      },
    },
  },
  defaultVariants: {
    emphasis: 'standard',
  },
})

const BreakdownValue = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
  variants: {
    emphasis: {
      standard: {},
      total: {
        fontFamily: 'display',
        fontSize: '18px',
        fontWeight: '700',
      },
    },
  },
  defaultVariants: {
    emphasis: 'standard',
  },
})

const ElementContainer = styled('div', {
  base: {
    marginTop: '20px',
  },
})

const PayActions = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '12px',
    marginTop: '20px',
  },
})

const PayErrorText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: '#9B3B3B',
    marginTop: '12px',
  },
})

const QuietNote = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

const BackLink = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
    transition: 'opacity {durations.fast} {easings.appleStandard}',
    _hover: {
      opacity: '0.7',
    },
  },
})

export {
  PayStack,
  PayHeader,
  PayTitle,
  PaySubtitle,
  BreakdownList,
  BreakdownRow,
  BreakdownLabel,
  BreakdownValue,
  ElementContainer,
  PayActions,
  PayErrorText,
  QuietNote,
  BackLink,
}
